import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { createInjectStore, deregister } from './reedux'

const injectReducers = (reducerPathObj, initialState)  => (WrappedComponent) => {
  return class InjectReducers extends Component {
    static WrappedComponent = WrappedComponent
    static contextTypes = {
      store: PropTypes.object.isRequired
    }

    register = createInjectStore(this.context.store)

    componentWillMount() {
      for (const path in reducerPathObj) {
        if (reducerPathObj.hasOwnProperty(path)) {
          this.register(path, initialState, reducerPathObj[path])
        }
      }
    }

    componentWillUnmount() {
      for (const path in reducerPathObj) {
        if (reducerPathObj.hasOwnProperty(path)) {
          deregister(path)
        }}
    }

    render() {
      return <WrappedComponent {...this.props}/>
    }
  }
}

export default injectReducers
